import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { a11yProps } from "./utils";
import { ITabsProps } from "./Tabs.types";
import { CustomLink } from "../Customlink/CustomLink";
import { useTheme } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

export const TabsList: React.FC<ITabsProps> = (props) => {
  const { tabData, selectedTab, onChange } = props;
  const theme = useTheme();

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={selectedTab}
          onChange={onChange}
          aria-label="basic tabs example"
          sx={{
            ".MuiTabs-flexContainer": {
                alignItems: "center"
            },
            "& .MuiTab-root": {
                color: theme.palette.text.primary,
            },
            "& .MuiTab-root.Mui-selected": {
                color: theme.palette.text.primary,
            }
        }}
        >
          {tabData.map((tab, index) => {
            return (
            //   <CustomLink to={tab.tabLink}>
                <Tab label={tab.tabLabel} {...a11yProps(index)} />
            //   </CustomLink>
            );
          })}
        </Tabs>
      </Box>
      {/* <CustomTabPanel value={value} index={0}>
        Item One
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        Item Two
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        Item Three
      </CustomTabPanel> */}
    </Box>
  );
};
